import React from "react";
import { CloseIcon } from "../../../../../Assets/Icons/svg";
import { Modal } from "semantic-ui-react";

const ForceStatusChangeModal = ({
  selectedLanguage,
  handleSave,
  setOpenForceModal,
  openForceModal,
  t,
}) => {
  return (
    <Modal
      className="assets-modal status-change-modal"
      size="tiny"
      open={openForceModal}
      onClose={() => {
        setOpenForceModal(false);
      }}
    >
      <div className={"header-container red"}>
        <span className="assets-header"> {t.workOrders.forceStatusChange}</span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => setOpenForceModal(false)}
          >
            <CloseIcon />
          </span>
        </div>
      </div>

      <Modal.Content>
        <p className="assets-label cancel-child">
          {t.workOrders.forceStatusTitle}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <div
          className={`modal-button-container ${
            selectedLanguage == "en" ? "mr-6" : "ml-10"
          }`}
        >
          <button
            className="modal-form-action-button"
            onClick={() => setOpenForceModal(false)}
          >
            {t.common.no}
          </button>

          <button
            onClick={() => {
              handleSave(true);
            }}
            className={`modal-form-action-button light-blue`}
          >
            {t.common.yes}
          </button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default ForceStatusChangeModal;
